<template>
  <!-- <a-row type="flex" justify="center" align="top">
    <a-col :md="12" :sm="12" :lg="14" :xs="12"> -->
  <div :class="NavBarClass" id="myTopnav">
    <a href="javascript:void(0);" style="background-color: green" class="icon" @click="myFunction">
      <i class="fa fa-bars"></i>
    </a>
    <a id="plsLogo"><img style="width:25px;height:25px" src="../assets/plslogo.png" /> PLS SYSTEM </a>

    <router-link class="routeLink" v-if="oUser && (oUser.Role == 'Guest' || oUser.Role == 'Moniter')" to="/">HÔM
      NAY</router-link>
    <router-link class="routeLink" v-if="oUser && (oUser.Role == 'Guest' || oUser.Role == 'Moniter')" to="/lastweek">7
      NGÀY TRƯỚC</router-link>
    <router-link class="routeLink" v-if="oUser && (oUser.Role == 'Guest' || oUser.Role == 'Moniter')" to="/all">TOÀN
      BỘ</router-link>
    <router-link class="routeLink" v-if="oUser && oUser.Role == 'Moniter'" to="/checkcode">CHECK CODE</router-link>
    <router-link class="routeLink" v-if="oUser && oUser.Role == 'Moniter'" to="/checkphone">CHECK SĐT</router-link>
    <router-link class="routeLink" v-if="oUser && oUser.Role == 'Moniter'" to="/blocklist">BLOCK LIST</router-link>
    <a class="LastChild">
      <a class="lblName">{{ TIME }} | Xin chào</a>
      <a class="lblDivine" style="padding:0px 10px">
        <hr />
      </a>
      <a-dropdown>
        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
          {{ oUser.Name }}
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item>
            <router-link to="/userinfo">
              <i class="fa fa-user-circle-o" aria-hidden="true"></i>
              Thông tin tài khoản
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <router-link to="/userhistory">
              <i class="fa fa-history" aria-hidden="true"></i>
              Lịch sử tương tác
            </router-link>
          </a-menu-item>
          <a-menu-item>
            <p @click="API_Logout()">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              Đăng xuất
            </p>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a>

    <!-- <a href="#home" class="active">Home</a>
      <a href="#news">News</a>
      <a href="#contact">Contact</a>
      <a href="#about">About</a> -->
  </div>
  <!-- </a-col>
    <a-col style="display:none" :md="12" :sm="12" :lg="10" :xs="12">
      <a-row>
        <a-col :xs="24" :sm="12" :md="12"  :lg="12">
          <b>{{ TIME }}</b> | Xin chào
        </a-col>
        <a-col :xs="24" :sm="12" :md="12"  :lg="12">
          <template>
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              {{ oUser.Name }}
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <router-link to="/userinfo">
                  <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                  Thông tin tài khoản
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/userhistory">
                  <i class="fa fa-history" aria-hidden="true"></i>
                  Lịch sử tương tác
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <p @click="API_Logout()">
                  <i class="fa fa-sign-out" aria-hidden="true"></i>
                  Đăng xuất
                </p>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
</a-col>
</a-row>

</a-col>
</a-row> -->
</template>
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
export default {
  name: "Navbar",
  computed: {
    ...mapState(["isLogin", "oUser"]),
  },
  data() {
    return {
      TIME: "",
      NavBarClass: "topnav",
    };
  },
  methods: {
    ...mapActions(["API_Logout", "Go_Route"]),
    UserInfo() {
      this.Go_Route("/UserInfo");
    },
    myFunction() {
      if (this.NavBarClass === "topnav") {
        this.NavBarClass += " responsive";
      } else {
        this.NavBarClass = "topnav";
      }
    },
  },
  mounted
    () {
    try {

      axios
        .get(this.$PRJ_DOMAIN + "/api/getnowtime")
        .then((res) => {
          if (res.State == 1)

            this.TIME = moment(res.Message).format("DD/MM/YYYY HH:mm:ss");
          else {
            this.TIME = moment().format("DD/MM/YYYY HH:mm:ss");
          }
        });

    } catch (error) {
      console.log(error.message);
    }
  },
};
</script>
<style scoped>
.fish.menu.vertical>.item {
  border: 1px solid #cccccc;
}

/* Add a black background color to the top navigation */
.topnav {
  background-color: #e0f0fa;
  overflow: hidden;
}

.LastChild {
  padding: 0px !important;
  float: right !important;
}

#plsLogo {
  pointer-events: none;
  text-align: unset !important;
  display: block;
  height: 39.5px;
  padding: 7px !important;
  color: white;
  background-color: #0f609a;
  font-size: 13px !important;
  border-right: 1px solid;
  font-weight: bold;
  font-size: 16px !important;
  width: 150px;
}

/* Style the links inside the navigation bar */
.topnav a {
  float: left;
  display: block;
  text-align: center;
  padding: 10px 14px;
  text-decoration: none;
  font-size: 13px;
  font-weight: 700;
  color: #2c3e50;
}

/* Change the color of links on hover */
.topnav a.routeLink:hover {
  background-color: green;
  color: white !important;
}

/* Add an active class to highlight the current page */
.topnav a.router-link-exact-active {
  background-color: green;
  color: white;
}

/* Hide the link that should open and close the topnav on small screens */
.topnav .icon {
  width: 40px;
  height: 39.5px;
  display: none;
}

@media screen and (max-width: 600px) {
  .topnav .LastChild {
    float: unset !important;
  }

  .topnav a#plsLogo {
    border-right: unset;
    width: calc(100% - 40px);
  }

  /* .topnav{
    width:50%;
  } */
  .topnav a:not(:first-child) {
    display: none;
  }

  .topnav a.icon {
    display: block;
  }
}

/* The "responsive" class is added to the topnav with JavaScript when the user clicks on the icon. This class makes the topnav look good on small screens (display the links vertically instead of horizontally) */
@media screen and (max-width: 600px) {
  .topnav.responsive .lblName {
    display: none;
  }

  .topnav.responsive a#plsLogo {
    border-right: unset;
    /* width: 40%; */
    width: calc(100% - 40px);
    margin-left: 40px;
  }

  .topnav.responsive {
    position: relative;
  }

  .topnav.responsive a.icon {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
  }

  /* .topnav.responsive a:first-child {
    width: 150px;
  } */
  .topnav.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
}
</style>